import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { getKioskOptions } from 'checkout/selectors/ui';
import getSidekick from 'shared/GetSidekick';
import { printToSidekick } from '../../../actions/sidekick';

class SidekickTicketPrint extends Component {
    sidekick = null;

    constructor(props) {
        super(props);

        this.state = {
            loaded: false
        }
    }

    componentDidMount() {
        (async () => {
            this.sidekick = await getSidekick(this.props.adminUrl);
            this.setState({loaded: true});
            this.printTickets();
        })()
    }

    printTickets = () => {
        if (this.props.kioskOptions.printReceipts || this.props.kioskOptions.printReceiptsAndTickets) {
            return this.props.printToSidekick(this.props.reservationId, this.sidekick);
        }
    }

    render() {
        return (
            <div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        reservationId: state.reservation.token,
        adminUrl: state.ui.uiConfig.adminUrl,
        kioskOptions: getKioskOptions(state),
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        printToSidekick,
    }, dispatch);
}

SidekickTicketPrint.propTypes = {
    adminUrl: PropTypes.string.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(SidekickTicketPrint)
